import { API_BASE_URL as API } from './apiConfig';
import { handleUnauthorized } from './authApi';

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('casapizza_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchBranches = async () => {
  try {
    const res = await fetch(`${API}/branches`, { headers: getAuthHeaders() });
    if (!res.ok) {
      if (res.status === 401) handleUnauthorized();
      return [];
    }
    return res.json();
  } catch (_) {
    return [];
  }
};
